import { render, staticRenderFns } from "./TimeComponent.vue?vue&type=template&id=52a590aa&"
import script from "./TimeComponent.vue?vue&type=script&lang=ts&"
export * from "./TimeComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports